import { render, staticRenderFns } from "./InFormDetail.vue?vue&type=template&id=30414e02&scoped=true&"
import script from "./InFormDetail.vue?vue&type=script&lang=js&"
export * from "./InFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./InFormDetail.vue?vue&type=style&index=0&id=30414e02&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30414e02",
  null
  
)

export default component.exports